<header
  #header
  class="bg-cloud-white d-flex align-items-center">
  <nav class="ps-3 py-3">
    <button
      [uiHidden]="!withMenuToggle()"
      class="btn btn-cloud-white"
      (click)="menuToggle.emit()">
      <fa-icon
        [icon]="icon.bars"
        class="text-ink-light"
        [fixedWidth]="true" />
    </button>
  </nav>
  <a routerLink="/">
    <img
      class="ms-6 ms-md-10"
      [src]="logo()"
      alt="logo" />
  </a>
  <div class="col"></div>
  <cas-top-navigation-phone class="me-6" />

  @if (withProfileInfo()) {
    <cas-top-navigation-quick-action class="d-xxl-inline me-6" />
    <cas-top-navigation-profile class="me-4 me-md-6" />
  }
</header>
